import React, { useEffect, useState } from 'react';
import { Task, tasksApi } from '../../lib/tasks';
import TaskItem from './TaskItem';
import { Button } from '../ui/button';
import LoeschenMitGrundDialog from '../ui/loeschen-mit-grund-dialog';
import TaskForm, { TaskFormValues } from './TaskForm';
import { useZuweisbareBenutzer } from './AufgabenFelder';
import { useAuth } from '../auth/use-auth';

export const TaskList: React.FC<{
  assignedUserId?: number;
  personHistoryId?: number;
  showCreate?: boolean;
}> = ({ assignedUserId, personHistoryId, showCreate = true }) => {
  const [items, setItems] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);
  // Ohne Liste stand hier ein Zahlenfeld für die Benutzer-ID (T-0057).
  const users = useZuweisbareBenutzer(showCreate && showNew);
  const { user } = useAuth();
  const ich = user ? Number.parseInt(String(user.id), 10) : 0;

  const load = async () => {
    setLoading(true);
    try {
      const list = await tasksApi.list({ assignedUserId, personHistoryId, status: 'open' });
      setItems(list);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [assignedUserId, personHistoryId]);

  const handleCreate = async (values: TaskFormValues) => {
    await tasksApi.create(values);
    setShowNew(false);
    await load();
  };
  const handleToggle = async (id: number, next: boolean) => {
    await tasksApi.toggleDone(id, next);
    await load();
  };
  const [zuLoeschen, setZuLoeschen] = useState<Task | null>(null);
  const handleDelete = (id: number) => setZuLoeschen(items.find((t) => t.id === id) ?? null);

  if (loading) {
    return <div className="text-sm text-muted-foreground">Lade Aufgaben ...</div>;
  }

  return (
    <div className="space-y-3">
      {showCreate && !showNew && (
        <div className="flex justify-end">
          <Button onClick={() => setShowNew(true)}>Neue Aufgabe</Button>
        </div>
      )}
      {showCreate && showNew && (
        <TaskForm
          initial={{ personHistoryId, assignedUserId: assignedUserId || ich || 0 }}
          onSubmit={handleCreate}
          onCancel={() => setShowNew(false)}
          users={users}
        />
      )}
      {items.length === 0 ? (
        <div className="rounded-md border p-3 text-sm text-muted-foreground">Keine Aufgaben</div>
      ) : (
        items.map(t => (
          <TaskItem
            key={t.id}
            id={t.id}
            title={t.title}
            description={t.description || undefined}
            dueAt={t.dueAt}
            isDone={t.isDone}
            assignedUserId={t.assignedUserId}
            createdByUserId={t.createdByUserId}
            onToggleDone={handleToggle}
            onDelete={handleDelete}
          />
        ))
      )}
      <LoeschenMitGrundDialog
        offen={zuLoeschen !== null}
        titel={`Aufgabe „${zuLoeschen?.title ?? ''}“ löschen?`}
        onAbbrechen={() => setZuLoeschen(null)}
        onLoeschen={async (grund) => {
          if (!zuLoeschen) return;
          await tasksApi.remove(zuLoeschen.id, grund);
          setZuLoeschen(null);
          await load();
        }}
      />
    </div>
  );
};

export default TaskList;


